import _JSON$stringify from "babel-runtime/core-js/json/stringify";


var storageFunc = {
	setLocal: function setLocal(name, content) {
		if (!name) return;
		if (typeof content !== "string") {
			content = _JSON$stringify(content);
		}
		try {
			window.localStorage.setItem(name, content);
		} catch (err) {
			consoleLog("setSession保存报错了", err);
			vm.alert("更新缓存数据失败,请重启壳子！");
		}
	},

	getLocal: function getLocal(name) {
		if (!name) return;
		return window.localStorage.getItem(name);
	},

	getJsonLocal: function getJsonLocal(name) {
		if (!name) return;
		var result = null;
		try {
			result = JSON.parse(window.localStorage.getItem(name));
		} catch (error) {
			result = null;
		}
		return result;
	},

	removeLocal: function removeLocal(name) {
		if (name == "DEVICE_INFO") {
			consoleLog("设备数据禁止清除");
			return;
		}
		if (!name) return;
		window.localStorage.removeItem(name);
	},

	removeAllLocal: function removeAllLocal(name) {
		consoleLog("删除所有保存的localStorage数据");
		window.localStorage.clear();
	},

	setSession: function setSession(name, content) {
		if (!name) return;
		if (typeof content !== "string") {
			content = _JSON$stringify(content);
		}
		try {
			window.sessionStorage.setItem(name, content);
		} catch (err) {
			consoleLog("setSession保存报错了", err);
			vm.alert("更新缓存数据失败,请重启壳子！");
		}
	},

	getSession: function getSession(name) {
		if (!name) return;
		return window.sessionStorage.getItem(name);
	},

	getJsonSession: function getJsonSession(name) {
		if (!name) return;
		var result = null;
		try {
			result = JSON.parse(window.sessionStorage.getItem(name));
		} catch (error) {
			result = null;
		}
		return result;
	},

	removeSession: function removeSession(name) {
		if (!name) return;
		window.sessionStorage.removeItem(name);
	},

	removeAllSession: function removeAllSession(name) {
		window.sessionStorage.clear();
	}
};

var plugin = {
	install: function install(Vue) {
		Vue.storage = storageFunc;

		Vue.prototype.$storage = storageFunc;
	},

	$storage: storageFunc
};

export default plugin;
export var install = plugin.install;


//////////////////
// WEBPACK FOOTER
// ./src/tools/storage.js
// module id = 38
// module chunks = 2